import React, { Component } from "react";

class Form extends Component {
    state = {
        operadores: []
    };
    componentDidMount() {
        this.setState({
            operadores: this.props.categoria.operadores
        });
    }
    addOperador = () => {
        this.setState({
            operadores: [...this.state.operadores, {}]
        });
    };
    removeOperador = index => {
        this.setState({
            operadores: this.state.operadores.filter((op, i) => i !== index)
        });
    };
    render() {
        const { operadores } = this.state;
        const { categoria, errors } = this.props;
        return (
            <div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Nombre:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='nombre'
                            name='nombre'
                            defaultValue={categoria.nombre}
                        />
                        {errors.nombre && (
                            <small className='help-blockParams form-Text'>
                                {errors.nombre[0]}
                            </small>
                        )}
                    </div>
                </div>
                {operadores.length > 0 && (
                    <FormOperadores
                        operadores={operadores}
                        categoria={categoria}
                        removeOperador={this.removeOperador}
                    />
                )}
                <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() => this.addOperador()}>
                    Añadir Operador
                </button>
            </div>
        );
    }
}

const FormOperadores = ({ operadores, removeOperador, categoria }) => {
    return (
        <div>
            <h2 className='form-section-title'>Operadores</h2>
            <div className='row form-group'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>$ Tonelada</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {operadores.map((operador, index) => {
                            return (
                                <tr key={operador.nombre + operador.sueldo}>
                                    <td>
                                        <input
                                            type='hidden'
                                            name={`operadores[${index}][id]`}
                                            value={operador.id}
                                        />
                                        <input
                                            type='text'
                                            className='text-input form-control'
                                            name={`operadores[${index}][nombre]`}
                                            defaultValue={operador.nombre}
                                            placeholder='Nombre'
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type='text'
                                            className='text-input form-control'
                                            name={`operadores[${index}][sueldo]`}
                                            placeholder='Precio Tonelada'
                                            defaultValue={operador.sueldo}
                                        />
                                    </td>
                                    <td>
                                        {!categoria.vehiculos && (
                                            <div className='table-data-feature'>
                                                <button
                                                    className='item'
                                                    data-toggle='tooltip'
                                                    data-placement='top'
                                                    title=''
                                                    type='button'
                                                    data-original-title='Borrar'
                                                    onClick={() =>
                                                        removeOperador(index)
                                                    }>
                                                    <i className='zmdi zmdi-delete' />
                                                </button>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Form;
